export const Logo = () => {
  return (
    <img
      src="/read21-logo.png"
      alt="Read 21"
      width={120}
      height={65}
      style={{ objectFit: "contain", maxWidth: "100%", maxHeight: "100%" }}
    />
  );
};
